module.exports = "/assets/data/a95b733f4b42aa79be62aedebb5ce041-CH65.data.json";